module.exports = __webpack_public_path__ + "static/media/4-non-surgical-treatment-02@3x.a67a70b0.jpg";